import { ApiResourceBaseClass as e } from "./baseApiCalls.js";
const s = "messaging/settings/router";
class r extends e {
  /**
   * Retrieves the current conversation router settings.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/messaging/settings/router`
   *
   * @returns {Promise<SamlListResponse>} A promise resolving to the router settings.
   */
  getConversationRouter = async () => {
    const { data: t } = await this.get(`${s}`);
    return t;
  };
  /**
   * Updates the conversation router settings.
   *
   * HTTP Verb: `PATCH`
   * Endpoint URL: `/messaging/settings/router`
   *
   * @param {boolean} enabled - A flag indicating whether the router should be enabled or disabled.
   * @returns {Promise<ConversationRouterData>} A promise that resolves to the updated router settings.
   */
  patchConversationRouter = async (t) => {
    const { data: a } = await this.patch(`${s}`, {
      enabled: t
    });
    return a;
  };
  /**
   * Retrives the conversation router configuration for a given WhatsApp account.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/messaging/settings/router/{whatsapp_account_id}"`
   *
   * @param {number} whatsapp_account_id - The ID of the WhatsApp account for which to retrieve the router configuration.
   * @returns {Promise<WhatsappRoutingConfig>} A promise that resolves to the updated router settings.
   */
  getWhatsAppRoutingConfig = async (t) => {
    const { data: a } = await this.get(
      `${s}/${t}`
    );
    return a;
  };
  /**
   * Creates the conversation router configuration for a given WhatsApp account.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/messaging/settings/router/{whatsapp_account_id}"`
   *
   * @param {number} whatsapp_account_id - The ID of the WhatsApp account for which to create the router configuration.
   * @param {WhatsappRoutingConfigPayload} payload - the payload to create the router configuration.
   * @returns {Promise<WhatsappRoutingConfig>} A promise that resolves to the updated router settings.
   */
  createWhatsAppRoutingConfig = async (t, a) => {
    const { data: n } = await this.post(
      `${s}/${t}`,
      a
    );
    return n;
  };
  /**
   * Updates the conversation router configuration for a given WhatsApp account.
   *
   * HTTP Verb: `PATCH`
   * Endpoint URL: `/messaging/settings/router/{whatsapp_account_id}"`
   *
   * @param {number} whatsapp_account_id - The ID of the WhatsApp account for which to create the router configuration.
   * @param {WhatsappRoutingConfigPayload} payload - the payload to create the router configuration.
   * @returns {Promise<WhatsappRoutingConfig>} A promise that resolves to the updated router settings.
   */
  updateWhatsAppRoutingConfig = async (t, a) => {
    const { data: n } = await this.patch(
      `${s}/${t}`,
      a
    );
    return n;
  };
}
export {
  r as ConversationRouter,
  s as ROUTER_RESOURCE_URI
};
